import { Main } from "screens/main";
import { LeaderboardService } from "shared/services/leaderboard.service";
import { EventBus } from "shared/emmiter";
import { PreloaderHelper } from "shared/helpers";
import { GameViewStorage } from "shared/storages";
import { DiscountPopupService } from "./disountPopup.service";
import { MapScreen } from "screens";
import { LanguageService, SoundService } from "shared/services";
import { UserService } from "./users.service";
import { BuildConfig } from "shared/config";
import config from "config";

export class MainMenuService {
    private leaderboardService: LeaderboardService;
    private isCanClick: boolean = true;

    public show(userName): void {
        if (!this.leaderboardService) {
            this.leaderboardService = new LeaderboardService();
        }

        const main = document.getElementById('main_page');
        main.style.visibility = 'visible';

        const helloUser = document.getElementById('hello_user');
        helloUser.innerHTML = `, ${userName}`;

        setTimeout(() => {
            this.addListeners();
            this.checkMusic();
            PreloaderHelper.togglePreloader(false);
        }, 500);

        EventBus.emmiter.on('hide_main', () => {
            this.hide();
        })
    }

    private checkMusic(): void {
        const buttons = document.getElementsByClassName('toggleSound');
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const musicState = user.isMusicOn;
        const prefixes = BuildConfig.getConfig();

        for (let i = 0; i < buttons.length; i++) {
            const btn = buttons[i];

            for (let j = 0; j < btn.childNodes.length; j++) {
                const child = btn.childNodes[j] as any;
                // console.log(child);

                if (child.nodeName === 'IMG' && musicState) {
                    //@ts-ignore
                    child.src = `${prefixes.bgPrefix}${subPath}assets/img/Sound_on.png`;
                }

                if (child.nodeName === 'IMG' && !musicState) {
                    //@ts-ignore
                    child.src = `${prefixes.bgPrefix}${subPath}assets/img/Sound_Icon.png`;
                }

                if (child.nodeName === 'SPAN' && musicState) {
                    const text = LanguageService.getTranslation('loc_turn_sound_off');

                    child.innerText = text;
                }

                if (child.nodeName === 'SPAN' && !musicState) {
                    const text = LanguageService.getTranslation('loc_turn_sound_on');
                    child.innerText = text;
                }
            }
        }
    }

    private async addListeners(): Promise<void> {
        let timer;
        const leaderboardBtn = document.getElementById('leaderboard_btn') as HTMLButtonElement;
        leaderboardBtn.addEventListener('click', async () => {
            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'open leaderboard',
                })
            }

            PreloaderHelper.togglePreloader(true);
            this.hide();
            this.leaderboardService.show();
        })

        const close_LD = document.getElementById('close_LD');
        close_LD.addEventListener('click', () => {
            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'close leaderboard',
                })
            }
            this.leaderboardService.hide();
        })

        const startBtn = document.getElementById('start_game') as HTMLButtonElement;
        // localStorage.clear()
        startBtn.addEventListener('click', async() => {
            this.hide();
            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'start game',
                });
            }

            // localStorage.clear()
            const isGameLoad = GameViewStorage.isViewLoad;
            const isMapLoad = GameViewStorage.isMapLoad;

            // await UserService.getUserData();

            if (!isMapLoad) {
                PreloaderHelper.togglePreloader(true);
                Main.instance.initApp();
            } else {
                PreloaderHelper.togglePreloader(true);
                MapScreen.instance.show();
            }

            const main = document.getElementById('main');
            main.style.display = 'none';
        })

        const discountBtn = document.getElementById('discount_btn') as HTMLButtonElement;

        discountBtn.addEventListener('click', () => {
            PreloaderHelper.togglePreloader(true);
            this.hide();
            DiscountPopupService.show(true, false);
        })
    }

    public async hide() {
        const main = document.getElementById('main_page');
        main.style.display = 'none';
    }
}